import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { PageAssessmentStatusType, UserInviteStatusType } from "api/api-data-types";
import { createReplaceAllReducer } from "store/utils";

type ComputedState = {
  pageAssessmentStatuses: PageAssessmentStatusType;
  userInviteStatuses: UserInviteStatusType;
};

const initialState = () => ({
  pageAssessmentStatuses: {},
  userInviteStatuses: {},
});

export const ComputedStore = createSlice({
  name: "computed",
  initialState,
  reducers: {
    savePageAssessmentStatuses: (state, action: PayloadAction<PageAssessmentStatusType>) => {
      state.pageAssessmentStatuses = {
        ...state.pageAssessmentStatuses,
        ...action.payload,
      };
    },
    saveUserInviteStatuses: (state, action: PayloadAction<UserInviteStatusType>) => {
      state.userInviteStatuses = {
        ...state.userInviteStatuses,
        ...action.payload,
      };
    },
  },
  extraReducers: createReplaceAllReducer<ComputedState>("computed", initialState),
});

export const computedStateActions = ComputedStore.actions;
